// @flow

import gql from 'graphql-tag';

const publicAppSearch = gql`
  query publicAppSearchQuery(
    $nameContains: String!
    $limit: Int!
    $excludeUpcoming: Boolean
  ) {
    getAppsByNameContains(
      nameContains: $nameContains
      limit: $limit
      excludeUpcoming: $excludeUpcoming
    ) {
      edges {
        id
        slug
        name
        images {
          url_64x64
          url_128x128
        }
      }
    }
  }
`;

export default publicAppSearch;
